import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.7496 3.15918L5.6164 16.519C5.18039 17.0422 4.96239 17.3038 4.95906 17.5248C4.95616 17.7168 5.04175 17.8996 5.19115 18.0203C5.36302 18.1592 5.70355 18.1592 6.38463 18.1592H15.4996L14.2496 28.1592L25.3828 14.7994C25.8188 14.2762 26.0368 14.0145 26.0401 13.7936C26.043 13.6015 25.9574 13.4188 25.808 13.2981C25.6361 13.1592 25.2956 13.1592 24.6145 13.1592H15.4996L16.7496 3.15918Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }